function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  container: auto;\n  max-width: 72rem;\n  margin: 0 auto;\n  padding: 1rem 1rem;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  container: auto;\n  max-width: 72rem;\n  margin: 0 auto;\n  padding: 1rem 1rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  text-align: center;\n  color: ",
        ";\n  padding: 2rem 0;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState, useCallback } from 'react';
import styled from '@emotion/styled';
import { PageHeader } from '@edusense/shared-ui-layout';
import { ProjectInfo } from './ProjectInfo';
import { ProjectContent } from './ProjectContent';
import { ProjectTags } from './ProjectTags';
import { ProjectSocialActions } from './ProjectSocialActions';
// 스타일드 컴포넌트 정의
var Container = styled.div(_templateObject(), function(props) {
    return props.theme.background;
}, function(props) {
    return props.className && props.className;
});
var ContentContainer = styled.div(_templateObject1());
var MainContentSection = styled.div(_templateObject2());
var CommentSection = styled.div(_templateObject3());
var CommentPlaceholder = styled.div(_templateObject4(), function(props) {
    return props.theme.textSecondary;
});
/**
 * 프로젝트 상세 템플릿 컴포넌트 (리팩토링 버전)
 * 
 * 아토믹 디자인의 템플릿(Template) 레벨 컴포넌트
 * 작은 컴포넌트들로 분리하여 재사용성과 유지보수성 향상
 */ var ProjectDetailTemplate = function(param) {
    var project = param.project, onBack = param.onBack, onComment = param.onComment, onShare = param.onShare, onEdit = param.onEdit, onDelete = param.onDelete, onDuplicate = param.onDuplicate, onReport = param.onReport, onDownload = param.onDownload, onViewCode = param.onViewCode, tmp = param.isFullscreen, initialIsFullscreen = tmp === void 0 ? false : tmp, className = param.className, commentSectionRef = param.commentSectionRef, refetchTrigger = param.refetchTrigger;
    var _project_stats, _project_stats1;
    // 로컬 상태 관리 (좋아요, 전체 화면, 로딩)
    var _useState = _sliced_to_array(useState(initialIsFullscreen), 2), isFullscreenMode = _useState[0], setIsFullscreenMode = _useState[1];
    var _project_isLiked;
    var _useState1 = _sliced_to_array(useState((_project_isLiked = project.isLiked) !== null && _project_isLiked !== void 0 ? _project_isLiked : false), 2), isLikedLocally = _useState1[0], setIsLikedLocally = _useState1[1];
    var _project_stats_likes, _ref;
    var _useState2 = _sliced_to_array(useState((_ref = (_project_stats_likes = (_project_stats = project.stats) === null || _project_stats === void 0 ? void 0 : _project_stats.likes) !== null && _project_stats_likes !== void 0 ? _project_stats_likes : project.likes) !== null && _ref !== void 0 ? _ref : 0), 2), likeCount = _useState2[0], setLikeCount = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), isLoadingLike = _useState3[0], setIsLoadingLike = _useState3[1];
    // 이벤트 핸들러 함수들
    var handleBack = function() {
        return onBack && onBack();
    };
    var handleLike = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var previousLikeStatus, previousLikeCount;
        return _ts_generator(this, function(_state) {
            if (isLoadingLike) return [
                2
            ];
            setIsLoadingLike(true);
            previousLikeStatus = isLikedLocally;
            previousLikeCount = likeCount;
            // 낙관적 업데이트
            setIsLikedLocally(!previousLikeStatus);
            setLikeCount(previousLikeStatus ? previousLikeCount - 1 : previousLikeCount + 1);
            // TODO: API 호출 로직 구현
            console.log('Like toggled for project:', project.id);
            setIsLoadingLike(false);
            return [
                2
            ];
        });
    }), [
        isLoadingLike,
        project.id,
        isLikedLocally,
        likeCount
    ]);
    var handleComment = function() {
        return onComment && onComment(project.id);
    };
    var handleShare = function() {
        return onShare && onShare(project.id);
    };
    var handleDownload = function() {
        console.log('Download requested for:', project.id);
        if (onDownload) {
            onDownload(project.id);
        } else if (project.projectZipFilePath) {
            var link = document.createElement('a');
            link.href = project.projectZipFilePath;
            link.download = "".concat(project.title || 'project', ".zip");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.warn('다운로드 핸들러 또는 파일 경로가 제공되지 않았습니다.');
        }
    };
    var _project_stats_comments, _ref1;
    return /*#__PURE__*/ React.createElement(Container, {
        className: className
    }, /*#__PURE__*/ React.createElement(PageHeader, {
        title: project.title,
        showBackButton: true,
        onBackClick: handleBack
    }), /*#__PURE__*/ React.createElement(ContentContainer, null, /*#__PURE__*/ React.createElement(MainContentSection, null, /*#__PURE__*/ React.createElement(ProjectInfo, {
        title: project.title,
        description: project.description,
        author: project.author,
        createdAt: project.createdAt
    }), /*#__PURE__*/ React.createElement(ProjectContent, {
        content: project.content
    }), /*#__PURE__*/ React.createElement(ProjectTags, {
        tags: project.tags
    })), /*#__PURE__*/ React.createElement(ProjectSocialActions, {
        isLiked: isLikedLocally,
        likeCount: likeCount,
        commentCount: (_ref1 = (_project_stats_comments = (_project_stats1 = project.stats) === null || _project_stats1 === void 0 ? void 0 : _project_stats1.comments) !== null && _project_stats_comments !== void 0 ? _project_stats_comments : project.comments) !== null && _ref1 !== void 0 ? _ref1 : 0,
        isLoadingLike: isLoadingLike,
        onLike: handleLike,
        onComment: handleComment,
        onShare: handleShare,
        onDownload: handleDownload
    }), /*#__PURE__*/ React.createElement(CommentSection, {
        ref: commentSectionRef
    }, /*#__PURE__*/ React.createElement(CommentPlaceholder, null, "댓글 기능은 구현 예정입니다."))));
};
export default ProjectDetailTemplate;
